module.exports = __webpack_public_path__ + "static/media/wrap.0a49bbad.usdz";